const zhLogin = {
    'MAIN_WEB_AGREEMENT': "协议"
    ,'MAIN_WEB_ARCHIVED': "已归档"
    ,'MAIN_WEB_BIND_MOBILE_PHONE': "绑定手机"
    ,'MAIN_WEB_CANCEL': "取消"
    ,'MAIN_WEB_COMBINATION_PASSWORD_OF_DIGITS_DIGITS_UPPERCASE_AND': "位，数字、大小写字母、字符组合密码"
    ,'MAIN_WEB_CONFIRM': "确认"
    ,'MAIN_WEB_CREATE': "创建"
    ,'MAIN_WEB_CURRENT_ORGANIZATION': "当前机构："
    ,'MAIN_WEB_DEPARTMENT_': "部门一"
    ,'MAIN_WEB_DEPARTMENT__FII': "部门二"
    ,'MAIN_WEB_DRAFT': "草稿"
    ,'MAIN_WEB_END_DATE': "结束日期"
    ,'MAIN_WEB_ENTER_A_PASSWORD': "请输入密码"
    ,'MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL': "请输入手机号码/邮箱/账号"
    ,'MAIN_WEB_EXISTING_ACCOUNT': "已有账号？"
    ,'MAIN_WEB_EXPORT': "导出"
    ,'MAIN_WEB_FAILED_TO_OBTAIN_TENANT_INFORMATION': "获取租户信息失败"
    ,'MAIN_WEB_FORGOT_PASSWORD': "忘记密码"
    ,'MAIN_WEB_MODIFIED_SUCCESSFULLY': "修改成功"
    ,'MAIN_WEB_HEADER_CHINESE': "中文"
    ,'MAIN_WEB_HEADER_ENGLISH': "英语"
    ,'MAIN_WEB_HEADER_FR': "法语"
    ,'MAIN_WEB_ID_NUMBER_IS_NOT_FORMAT': "身份证号格式不正确"
    ,'MAIN_WEB_INCORRECT_CONTACT_NUMBER': "联系电话不正确"
    ,'MAIN_WEB_INCORRECT_MOBILE_PHONE_NUMBER': "手机号码不正确"
    ,'MAIN_WEB_I_HAVE_READ_AND_AGREE': "我已阅读并同意"
    ,'MAIN_WEB_LANDLINE_NUMBER_IS_INCORRECT': "座机号码不正确"
    ,'MAIN_WEB_LOAD_INTO_MODULE': "载入模块中。。。"
    ,'MAIN_WEB_LOGIN': "登录"
    ,'MAIN_WEB_LOG_ON_NOW': "马上登录"
    ,'MAIN_WEB_LOG_OUT': "退出登录"
    ,'MAIN_WEB_MODIFY': "修改"
    ,'MAIN_WEB_NAME': "名称"
    ,'MAIN_WEB_NO_ACCOUNT_YET': "还没账号？"
    ,'MAIN_WEB_OBTAIN_VERIFICATION_CODE': "获取验证码"
    ,'MAIN_WEB_OK': "确定"
    ,'MAIN_WEB_PASSWORD': "密码"
    ,'MAIN_WEB_PASSWORD_LOGON': "密码登录"
    ,'MAIN_WEB_PERSONAL_INFORMATION': "个人信息"
    ,'MAIN_WEB_PLEASE_CONFIRM_WHETHER_IT_IS_REGISTERED': "请确认是否已注册"
    ,'MAIN_WEB_PLEASE_ENTER': "请输入"
    ,'MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD': "请输入新密码"
    ,'MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE': "请输入六位验证码"
    ,'MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE': "请输入验证码"
    ,'MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER': "请输入正确的手机号"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER': "请输入手机号"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND': "请输入手机号码/邮箱"
    ,'MAIN_WEB_PLEASE_SELECT': "请选择"
    ,'MAIN_WEB_PLEASE_SET_8_20_DIGITS_COMBINATIN_OF_NUMBER': "请设置8-20位，数字、大小写字母、字符组合密码"
    ,'MAIN_WEB_PUBLISHED': "已发布"
    ,'MAIN_WEB_QUERY': "查询"
    ,'MAIN_WEB_REBIND': "重新绑定"
    ,'MAIN_WEB_REGISTERED_SUCCESSFULLY': "注册成功"
    ,'MAIN_WEB_REGISTER_NOW': "立即注册"
    ,'MAIN_WEB_REGISTRATION': "注册"
    ,'MAIN_WEB_RESET': "重置"
    ,'MAIN_WEB_RESET_PASSWORD': "重置密码"
    ,'MAIN_WEB_SECURITY_SETTINGS': "安全设置"
    ,'MAIN_WEB_SET_PASSWORD': "设置密码"
    ,'MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION': "共享教育资源 传承人类文明"
    ,'MAIN_WEB_START_DATE': "开始日期"
    ,'MAIN_WEB_STATUS': "状态"
    ,'MAIN_WEB_THEN_RETRIEVE': "后重新获取"
    ,'MAIN_WEB_THE_BOUND_PHONE_IS_NOT_VERIFIED': "已绑定手机：138****8293 未验证"
    ,'MAIN_WEB_THE_CURRENT_TENANT_HAS_BEEN_DISABLED': "当前租户已被禁用"
    ,'MAIN_WEB_THE_ISPHONE_AND_MAILBOX_FORMAT_IS_INCORRECT': "手机号码/邮箱格式不正确"
    ,'MAIN_WEB_THE_MAILBOX_FORMAT_IS_INCORRECT': "邮箱格式不正确"
    ,'MAIN_WEB_THIS_TYPE_IS_NOT_AVAILABLE': "无此类型"
    ,'MAIN_WEB_TO': "至"
    ,'MAIN_WEB_UNIFIED_SOCIAL_CODE_IS_COPMPOSED': "统一社会信用代码18位数字或大写字母组成"
    ,'MAIN_WEB_USER': "用户"
    ,'MAIN_WEB_USER_AGREEMENT': "《用户协议》"
    ,'MAIN_WEB_USER_AGREEMENT_YOI': "用户协议"
    ,'MAIN_WEB_VERIFICATION': "验证"
    ,'MAIN_WEB_VERIFICATION_CODE_LOGIN': "验证码登录"
    ,'MAIN_WEB_WELCOME_TO_LOGIN': "欢迎登录"
    ,'MAIN_WEB_WELCOME_TO_REGISTER': "欢迎注册"
    ,'MAIN_WEB_YOUR_ACCOUNT_BELONGS_TO_MULTIPLE_ORGANIZATIONS_PLEASE': "您的账号属于多个组织，请选择要登录的组织"
    ,'MAIN_WEB_YOUR_ACCOUNT_HAS_MULTIPLE_IDENTITIES_PLEASE_SELECT': "您的账号拥有多个身份，请选择要登录的身份"
    ,'MAIN_WEB_YOUR_CURRENT_LOCATION': "您当前在："
    ,'MAIN_WEB_YOU_DO_NOT_HAVE_AN_ORGANIZATION_YET': "你还没有组织，请联系管理员添加权限。"
}

const enLogin = {
    'MAIN_WEB_AGREEMENT': "Agreement"
    ,'MAIN_WEB_ARCHIVED': "Archived"
    ,'MAIN_WEB_BIND_MOBILE_PHONE': "Bind Mobile Phone"
    ,'MAIN_WEB_CANCEL': "Cancel"
    ,'MAIN_WEB_COMBINATION_PASSWORD_OF_DIGITS_DIGITS_UPPERCASE_AND': "A Combination of Digits, Digits, Uppercase and Lowercase Letters, and Characters."
    ,'MAIN_WEB_CONFIRM': "Confirm"
    ,'MAIN_WEB_CREATE': "Create"
    ,'MAIN_WEB_CURRENT_ORGANIZATION': "Current Organization:"
    ,'MAIN_WEB_DEPARTMENT_': "Department 1"
    ,'MAIN_WEB_DEPARTMENT__FII': "Department 2"
    ,'MAIN_WEB_DRAFT': "Draft"
    ,'MAIN_WEB_END_DATE': "End Date"
    ,'MAIN_WEB_ENTER_A_PASSWORD': "Enter a Password"
    ,'MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL': "Please Enter Your Mobile Phone Number/Email Address/Account Number."
    ,'MAIN_WEB_EXISTING_ACCOUNT': "Existing Account?"
    ,'MAIN_WEB_EXPORT': "Export"
    ,'MAIN_WEB_FAILED_TO_OBTAIN_TENANT_INFORMATION': "Failed to Obtain Tenant Information"
    ,'MAIN_WEB_FORGOT_PASSWORD': "Forgot Password"
    ,'MAIN_WEB_MODIFIED_SUCCESSFULLY': "Modified Successfully"
    ,'MAIN_WEB_HEADER_CHINESE': "Chinese"
    ,'MAIN_WEB_HEADER_ENGLISH': "English"
    ,'MAIN_WEB_HEADER_FR': "French"
    ,'MAIN_WEB_ID_NUMBER_IS_NOT_FORMAT': "The ID Number Format Is Incorrect."
    ,'MAIN_WEB_INCORRECT_CONTACT_NUMBER': "Incorrect Contact Number"
    ,'MAIN_WEB_INCORRECT_MOBILE_PHONE_NUMBER': "Incorrect Mobile Phone Number"
    ,'MAIN_WEB_I_HAVE_READ_AND_AGREE': "I Have Read and Agree"
    ,'MAIN_WEB_LANDLINE_NUMBER_IS_INCORRECT': "Incorrect Landline Number"
    ,'MAIN_WEB_LOAD_INTO_MODULE': "Load the Module..."
    ,'MAIN_WEB_LOGIN': "Login"
    ,'MAIN_WEB_LOG_ON_NOW': "Log on Now"
    ,'MAIN_WEB_LOG_OUT': "Log out"
    ,'MAIN_WEB_MMMMMM': "9999999"
    ,'MAIN_WEB_MODIFY': "Modify"
    ,'MAIN_WEB_NAME': "Name"
    ,'MAIN_WEB_NO_ACCOUNT_YET': "No Account Yet?"
    ,'MAIN_WEB_OBTAIN_VERIFICATION_CODE': "Get Verification Code"
    ,'MAIN_WEB_OK': "OK"
    ,'MAIN_WEB_PASSWORD': "Password"
    ,'MAIN_WEB_PASSWORD_LOGON': "Password"
    ,'MAIN_WEB_PERSONAL_INFORMATION': "Personal Information"
    ,'MAIN_WEB_PLEASE_CONFIRM_WHETHER_IT_IS_REGISTERED': "Please Confirm Whether It Is Registered"
    ,'MAIN_WEB_PLEASE_ENTER': "Please Enter"
    ,'MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD': "Please Enter a New Password"
    ,'MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE': "Please Enter a Six-Digit Verification Code"
    ,'MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE': "Please Enter a Verification Code"
    ,'MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER': "Please Enter the Correct Mobile Phone Number"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER': "Please Enter Your Mobile Phone Number"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND': "Please Enter Your Mobile Phone Number/Email Address."
    ,'MAIN_WEB_PLEASE_SELECT': "Please Select"
    ,'MAIN_WEB_PLEASE_SET_8_20_DIGITS_COMBINATIN_OF_NUMBER': "Please Set a Password of 8-20 Digits, Numbers, Uppercase and Lowercase Letters, and Characters."
    ,'MAIN_WEB_PUBLISHED': "Published"
    ,'MAIN_WEB_QUERY': "Query"
    ,'MAIN_WEB_REBIND': "Rebind"
    ,'MAIN_WEB_REGISTERED_SUCCESSFULLY': "Registered Successfully"
    ,'MAIN_WEB_REGISTER_NOW': "Register Now"
    ,'MAIN_WEB_REGISTRATION': "Registration"
    ,'MAIN_WEB_RESET': "Reset"
    ,'MAIN_WEB_RESET_PASSWORD': "Reset Password"
    ,'MAIN_WEB_SECURITY_SETTINGS': "Security Settings"
    ,'MAIN_WEB_SET_PASSWORD': "Set Password"
    ,'MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION': "Sharing Educational Resources to Inherit Human Civilization"
    ,'MAIN_WEB_START_DATE': "Start Date"
    ,'MAIN_WEB_STATUS': "Status"
    ,'MAIN_WEB_THEN_RETRIEVE': "Then Retrieve"
    ,'MAIN_WEB_THE_BOUND_PHONE_IS_NOT_VERIFIED': "Bound Phone': 138 **** 8293 Not Verified"
    ,'MAIN_WEB_THE_CURRENT_TENANT_HAS_BEEN_DISABLED': "The Current Tenant Has Been Disabled."
    ,'MAIN_WEB_THE_ISPHONE_AND_MAILBOX_FORMAT_IS_INCORRECT': "Incorrect Mobile Phone Number/Email Format"
    ,'MAIN_WEB_THE_MAILBOX_FORMAT_IS_INCORRECT': "Incorrect Mailbox Format"
    ,'MAIN_WEB_THIS_TYPE_IS_NOT_AVAILABLE': "This Type Is Not Available."
    ,'MAIN_WEB_TO': "to"
    ,'MAIN_WEB_UNIFIED_SOCIAL_CODE_IS_COPMPOSED': "Unified Social Credit Code Consisting of 18 Digits Or Uppercase Letters"
    ,'MAIN_WEB_USER': "User"
    ,'MAIN_WEB_USER_AGREEMENT': "User Agreement"
    ,'MAIN_WEB_USER_AGREEMENT_YOI': "User Agreement"
    ,'MAIN_WEB_VERIFICATION': "Verification"
    ,'MAIN_WEB_VERIFICATION_CODE_LOGIN': "Verification Code"
    ,'MAIN_WEB_WELCOME_TO_LOGIN': "Welcome to Login"
    ,'MAIN_WEB_WELCOME_TO_REGISTER': "Welcome to Register"
    ,'MAIN_WEB_YOUR_ACCOUNT_BELONGS_TO_MULTIPLE_ORGANIZATIONS_PLEASE': "Your Account Belongs to Multiple Organizations. Select the Organization to Log on."
    ,'MAIN_WEB_YOUR_ACCOUNT_HAS_MULTIPLE_IDENTITIES_PLEASE_SELECT': "Your Account Has Multiple Identities. Select the Identity to Log on."
    ,'MAIN_WEB_YOUR_CURRENT_LOCATION': "Current location:"
}

const frLogin = {
    'MAIN_WEB_AGREEMENT': "protocole"
    ,'MAIN_WEB_ARCHIVED': "Archivé"
    ,'MAIN_WEB_BIND_MOBILE_PHONE': "Téléphone mobile contraignant"
    ,'MAIN_WEB_CANCEL': "Annuler"
    ,'MAIN_WEB_COMBINATION_PASSWORD_OF_DIGITS_DIGITS_UPPERCASE_AND': "des chiffres et des symboles"
    ,'MAIN_WEB_CONFIRM': "Confirmer"
    ,'MAIN_WEB_CREATE': "créer"
    ,'MAIN_WEB_CURRENT_ORGANIZATION': "L'organisation actuelle:"
    ,'MAIN_WEB_DEPARTMENT_': "Département 1"
    ,'MAIN_WEB_DEPARTMENT__FII': "Département 2"
    ,'MAIN_WEB_DRAFT': "brouillon"
    ,'MAIN_WEB_END_DATE': "Date de terminer"
    ,'MAIN_WEB_ENTER_A_LOGIN_ACCOUNT': "Entrer dans un Compte de Connexion"
    ,'MAIN_WEB_ENTER_A_PASSWORD': "Veuillez entrer le mot de passe"
    ,'MAIN_WEB_ENTER_THE_CORRECT_LOGON_ACCOUNT': "Entrer la Bonne Connexion Compte"
    ,'MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL': "Veuillez saisir votre numéro de téléphone portable/adresse de mail/numéro de compte."
    ,'MAIN_WEB_EXISTING_ACCOUNT': "Se connecter à un compte existant?"
    ,'MAIN_WEB_EXPORT': "Exporter"
    ,'MAIN_WEB_FAILED_TO_OBTAIN_TENANT_INFORMATION': "obtenir l'information d'utilisateur à l'échec"
    ,'MAIN_WEB_FORGOT_PASSWORD': "Mot de passe oublié"
    ,'MAIN_WEB_HEADER_CHINESE': "Chinois"
    ,'MAIN_WEB_HEADER_ENGLISH': "Anglais"
    ,'MAIN_WEB_HEADER_FR': "Français"
    ,'MAIN_WEB_ID_NUMBER_IS_NOT_FORMAT': "Le format de numéro de carte d'identité est incorrect"
    ,'MAIN_WEB_INCORRECT_CONTACT_NUMBER': "Le numéro de contact est incorrect"
    ,'MAIN_WEB_INCORRECT_MOBILE_PHONE_NUMBER': "Le numéro de téléphone portable est incorrect"
    ,'MAIN_WEB_I_HAVE_READ_AND_AGREE': "J'ai lu et approuvé"
    ,'MAIN_WEB_LANDLINE_NUMBER_IS_INCORRECT': "Le numéro de téléphone fixe est incorrect"
    ,'MAIN_WEB_LOAD_INTO_MODULE': "Le chargement est en cours"
    ,'MAIN_WEB_LOGIN': "Se connecter"
    ,'MAIN_WEB_LOG_ON_NOW': "Se connecter"
    ,'MAIN_WEB_LOG_OUT': "se déconnecter"
    ,'MAIN_WEB_MODIFIED_SUCCESSFULLY': "Modifié Avec Succès"
    ,'MAIN_WEB_MODIFY': "modifier"
    ,'MAIN_WEB_NAME': "Nom"
    ,'MAIN_WEB_NO_ACCOUNT_YET': "Ne pas encore avoir un compte?"
    ,'MAIN_WEB_OBTAIN_VERIFICATION_CODE': "Obtenir le code de vérification"
    ,'MAIN_WEB_OK': "Confirmer"
    ,'MAIN_WEB_PASSWORD': "Mot de passe"
    ,'MAIN_WEB_PASSWORD_LOGON': "Mot de passe"
    ,'MAIN_WEB_PERSONAL_INFORMATION': "informations personnelles"
    ,'MAIN_WEB_PLEASE_CONFIRM_WHETHER_IT_IS_REGISTERED': "Veuillez vérifier si le compte a été enregistré"
    ,'MAIN_WEB_PLEASE_ENTER': "Veuillez entrer"
    ,'MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD': "Veuillez saisir un nouveau mot de passe"
    ,'MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE': "Veuillez saisir le code de vérification avec 6 caractères"
    ,'MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE': "Veuillez saisir le code de vérification"
    ,'MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER': "Veuillez entrer le numéro de téléphone portable correct"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER': "Veuillez saisir le numéro de téléphone"
    ,'MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND': "Veuillez saisir le numéro de téléphone portable / adresse de mail"
    ,'MAIN_WEB_PLEASE_SELECT': "Veuillez choisir"
    ,'MAIN_WEB_PLEASE_SET_8_20_DIGITS_COMBINATIN_OF_NUMBER': "Utilisez 8-20 caractères avec des lettres, des chiffres et des symboles"
    ,'MAIN_WEB_PUBLISHED': "Publié"
    ,'MAIN_WEB_QUERY': "Renseigner"
    ,'MAIN_WEB_REBIND': "Rebind"
    ,'MAIN_WEB_REGISTERED_SUCCESSFULLY': "réussir l'inscription"
    ,'MAIN_WEB_REGISTER_NOW': "S'inscrire tout de suite"
    ,'MAIN_WEB_REGISTRATION': "S'inscrire"
    ,'MAIN_WEB_RESET': "remettre"
    ,'MAIN_WEB_RESET_PASSWORD': "remettre le mot de passe"
    ,'MAIN_WEB_SECURITY_SETTINGS': "Les paramètres de sécurité"
    ,'MAIN_WEB_SET_PASSWORD': "Saisir votre mot de passe"
    ,'MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION': "Partager des ressources éducatives et hériter la civilisation des humains"
    ,'MAIN_WEB_START_DATE': "Date de commencer"
    ,'MAIN_WEB_STATUS': "Statut"
    ,'MAIN_WEB_TESSSS999': "99999999"
    ,'MAIN_WEB_THEN_RETRIEVE': "Obtenir à nouveau"
    ,'MAIN_WEB_THE_BOUND_PHONE_IS_NOT_VERIFIED': "Le téléphone portable a été lié à 138 **** 8293 non vérifié"
    ,'MAIN_WEB_THE_CURRENT_TENANT_HAS_BEEN_DISABLED': "Cet utilisateur a été désactivé."
    ,'MAIN_WEB_THE_ISPHONE_AND_MAILBOX_FORMAT_IS_INCORRECT': "Le numéro de téléphone portable / format de mail est incorrect"
    ,'MAIN_WEB_THE_MAILBOX_FORMAT_IS_INCORRECT': "Le format de mail est incorrect"
    ,'MAIN_WEB_THIS_TYPE_IS_NOT_AVAILABLE': "Aucun type"
    ,'MAIN_WEB_TO': "pour"
    ,'MAIN_WEB_UNIFIED_SOCIAL_CODE_IS_COPMPOSED': "Code uniforme de crédit social composé de 18 chiffres ou de lettres majuscules"
    ,'MAIN_WEB_USER': "utilisateur"
    ,'MAIN_WEB_USER_AGREEMENT': "Accord de l'utilisateur"
    ,'MAIN_WEB_USER_AGREEMENT_YOI': "Accord de l'utilisateur"
    ,'MAIN_WEB_VERIFICATION': "Vérifier"
    ,'MAIN_WEB_VERIFICATION_CODE_LOGIN': "Vérification Code"
    ,'MAIN_WEB_WELCOME_TO_LOGIN': "Bienvenue à la connexion"
    ,'MAIN_WEB_WELCOME_TO_REGISTER': "Bienvenue à l'inscription"
    ,'MAIN_WEB_YOUR_ACCOUNT_BELONGS_TO_MULTIPLE_ORGANIZATIONS_PLEASE': "Votre compte appartient à plusieurs organisations, veuillez sélectionner l'organisation pour se connecter"
    ,'MAIN_WEB_YOUR_ACCOUNT_HAS_MULTIPLE_IDENTITIES_PLEASE_SELECT': "Votre Compte A Plusieurs Identités. Sélectionnez L'identité se Connecter."
    ,'MAIN_WEB_YOUR_CURRENT_LOCATION': "Vous êtes:"
    ,'MAIN_WEB_YOU_DO_NOT_HAVE_AN_ORGANIZATION_YET': "Vous Nn'avez pas encore d'organization. Veuillez contacter l'administrateur."
}
export default {
    zhLogin,
    enLogin,
    frLogin
}